import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { LocationSearch } from '../../GooglePlacesAutocomplete/LocationSearch';
import { formSelectInlineClassNames } from '../../../theme/component-styles';
import { ISelectMeta } from '../../../data-models/field3.data-model';
import { IBaseFieldProps } from './types';

export function FieldLocation(props: IBaseFieldProps<ISelectMeta<unknown>>) {
  const { formField, formProps } = props;
  const { ref, onChange, value } = formProps;
  const { multi, withLocationIcon, inlinePopper } = formField.rendererMeta ?? {};
  const { disabled = false, variant } = formField ?? {};
  const className = variant === 'form-inline' ? formSelectInlineClassNames : '';

  return (
    <LocationSearch
      className={className}
      disabled={disabled}
      initialValue={value}
      inlinePopper={inlinePopper}
      multiple={multi}
      onChange={onChange}
      ref={ref}
      startAdornment={
        withLocationIcon ? (
          // In the single case the text input's own left padding spaces it off the icon; chips have
          // no such padding, so the multi case carries the equivalent gap on the icon itself.
          <PlaceOutlinedIcon sx={{ color: 'text.secondary', fontSize: 16, mr: multi ? '6px' : 0 }} />
        ) : undefined
      }
    />
  );
}
